import React from "react";
import { Box } from "@mui/material";
import NoContant from "../../assests/svg/no-contant";

const NoContentFound = () => {
  return (
    <Box display={"flex"}>
      <NoContant />
    </Box>
  );
};

export default NoContentFound;
